import Game from 'Game';
import { IPlinkoConfig } from './IPlinkoConfig';

export function getPlinkoConfig(): IPlinkoConfig {
    return Game.resource.get<IPlinkoConfig>('plinkoConfig');
}
